export default "__VITE_ASSET__BKyXevac__"